import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Alert from "@mui/material/Alert";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Cookies from "js-cookie";
import * as React from "react";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";

import {useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../context/AuthContext";

import {login} from "../services/requests/ApiRequests";

const theme = createTheme();

export default function SignIn() {
	let navigate = useNavigate();
	const location = useLocation();
	const state = (location.state) ?? {};
	const {t} = useTranslation();

	const [error, setError] = React.useState(null);

	const [isBlocked, setIsBlocked] = React.useState(false);

	const {user, refresh} = useAuth()
	const authCookie = Cookies.get("auth");

	useEffect(() => {
		if (state && state?.message === 'blocked') {
			setIsBlocked(true);
		} else {
			setIsBlocked(false);
		}

	}, [state])

	// Role-based redirect for already authenticated users
	if (!!authCookie && user) {
		const userRole = user.role?.toLowerCase();
		Cookies.remove("simpalsid.lang");
		if (userRole === 'user') {
			navigate("/acps/");
		} else if (userRole === 'admin' || userRole === 'super_admin') {
			navigate("/");
		} else {
			// Fallback for unrecognized roles
			navigate("/acps/");
		}
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);

		if (data.get("login") != "" && data.get("password") != "") {
			let credentials = {
				login: data.get("login"),
				pass: data.get("password"),
			};

			login(credentials)
				.then(async (data) => {
					if (data.data.success == true) {
						await refresh();
						// Note: Since refresh updates the user state, we let ProtectedRoute
						// handle the redirection logic for authenticated users at login page
						// This prevents race conditions and ensures consistent behavior
						window.location.reload(); // Force re-evaluation of auth state
					}

				})
				.catch((err) => {
					setError(err.response.data.detail)
					// alert(err.response.data);
				});
		} else {
			console.log("wrong data");
		}
	};

	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};

	const open = Boolean(anchorEl);
	const id = open ? "simple-popper" : undefined;

	return (
		<Box
			sx={{
				width: "100%",
				height: "90%",
				position: "absolute",
				marginTop: 9,
			}}
		>
			<ThemeProvider theme={theme}>
				<Container component="main" maxWidth="xs">
					<CssBaseline/>
					<Box
						sx={{
							marginTop: 8,
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<Avatar sx={{m: 1, bgcolor: "secondary.main"}}>
							<LockOutlinedIcon/>
						</Avatar>
						<Typography component="h1" variant="h5">
							Sign in
						</Typography>
						<Box
							component="form"
							onSubmit={handleSubmit}
							noValidate
							sx={{mt: 1}}
						>
							<TextField
								margin="normal"
								required
								fullWidth
								id="login"
								label="Login"
								name="login"
								autoComplete="login"
								autoFocus
							/>
							<TextField
								margin="normal"
								required
								fullWidth
								name="password"
								label="Password"
								type="password"
								id="password"
								autoComplete="current-password"
							/>
							<FormControlLabel
								control={
									<Checkbox
										value="remember"
										color="primary"
									/>
								}
								label="Remember me"
							/>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								sx={{mt: 3, mb: 2}}
							>
								Sign In
							</Button>
							{/*<Grid container>*/}
							{/*	<Grid item xs>*/}
							{/*		<Link variant="body2" onClick={handleClick}>*/}
							{/*			Forgot login or password?*/}
							{/*		</Link>*/}
							{/*	</Grid>*/}
							{/*</Grid>*/}
							{/*<Popper id={id} open={open} anchorEl={anchorEl}>*/}
							{/*	<Box*/}
							{/*		sx={{*/}
							{/*			border: 1,*/}
							{/*			p: 1,*/}
							{/*			bgcolor: "background.paper",*/}
							{/*		}}*/}
							{/*	>*/}
							{/*		You need to contact Simpals to get a login*/}
							{/*		and password.*/}
							{/*	</Box>*/}
							{/*</Popper>*/}
						</Box>
						<Box>

							{isBlocked && <Alert severity="error">{t("account_blocked_message")}</Alert>}
							{error && <Alert severity="error">{error}</Alert>}
						</Box>
					</Box>
				</Container>
			</ThemeProvider>
		</Box>
	);
}
